export default __webpack_public_path__ + "static/media/home.2faa5f14.svg";